var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-display',_vm._b({},'message-display',Object.assign({}, {text: _vm.text, backUrl: _vm.backUrl, errorCode: _vm.errorCode, languageCode: _vm.languageCode}, _vm.messageState),false))}
var staticRenderFns = []

export { render, staticRenderFns }